import React, { useEffect } from 'react';
import { Container, Grid } from '@material-ui/core';
import HomeBanner from '../../components/HomeBanner';
import NewsTicker from '../../components/NewsTicker';
// import HomeAbout from './About';
import MessageFromCommissioner from './MessageFromCommissioner';
import InfoTab from './InfoTab';
import HomeMembers from './HomeMembers';
import LinkOptions from './LinksOptions';
import ElectionCommissioner from '../../components/ElectionCommissioners';
import HomeGallery from './Gallery';
// import HomeBlogs from './latestnews';
import SocialFeeds from './SocialFeeds';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNews, fetchTickerNews } from '../../services/news.service';
import News from '../../models/news.model';
// import VoterList from './VoterList';
import ITsubsystem from './IT-subsystem';
import HomeJacketModal from '../../components/HomeJacket';
import LocalElectionTimer from './LocalElectionTimer';

interface state {
  news: {
    news: Array<News>,
    loading: false,
    important: Array<News>,
    tickerNews: any
  }
}

const Home: React.FC = () => {


  const state = useSelector((state: state) => {
    const { news } = state;
    return news;
  })
  const { loading: loadingNews, news, important, tickerNews } = state;
  const dispatch = useDispatch();

  useEffect(() => {
    getTickerNews();
    if (!news) dispatch(fetchNews());
  }, [dispatch]) //eslint-disable-line

  const getTickerNews = () => {
    dispatch(fetchTickerNews());
  }

  return (
    <>

      <NewsTicker news={tickerNews} loading={loadingNews} />
      <HomeBanner home={true} />
      <Container maxWidth="lg">
        <ITsubsystem />
      </Container>
      <LocalElectionTimer />
      <div className="section-padding-2">
        {/* <HomeAbout/> */}
        <Container maxWidth="lg">
          <Grid container spacing={0} >
            <Grid item xs={12} lg={7} md={6} xl={6}>
              {/* <VoterList/>  */}
              <MessageFromCommissioner />
            </Grid>
            <Grid item xs={12} lg={5} md={6} xl={6}>
              <ElectionCommissioner />
            </Grid>
          </Grid>
        </Container>
      </div>
      {/* // info tab + members  */}
      <div className="mt-2 mb-2 bg-primary">
        <Container maxWidth="lg" >
          <Grid container spacing={2} className="align-item-center">
            <Grid item xs={12} lg={8} md={6} xl={8}>
              <InfoTab
                news={news || []}
                loadingNews={loadingNews}
              />
            </Grid>
            <Grid item xs={12} lg={4} md={6} xl={4}>
              <HomeMembers />
            </Grid>
          </Grid>
        </Container>
      </div>
      {/* // info tab + members  */}

      {/* <HomeBlogs
      news={news}
      loading={loadingNews}
    /> */}
      <LinkOptions />
      <HomeGallery />
      <SocialFeeds />
      {important?.map((item, itemIndex) => {
        return (
          <HomeJacketModal
            open={true}
            data={item}
            itemIndex={itemIndex}
          />
        )
      })}

    </>
  );
}

export default Home;